import "./WaterHeater.module.css";
import Header from "@/reusable_sections/Header";
import WaterHeaterHero from "./sections/WaterHeaterHero";
import WaterHeaterServices from "./sections/WaterHeaterServices";
import RepairReplace from "./sections/RepairReplace";
import BrandRibbon from "./sections/BrandRibbon";
import WaterHeaterProcess from "./sections/WaterHeaterProcess";
import HeaterTrouble from "./sections/HeaterTrouble";
import Footer from "@/reusable_sections/Footer";
import ProblemFinder from "./sections/ProblemFinder";
import WaterHeaters from "./sections/WaterHeaters";
import ServiceArea from "./sections/ServiceArea";
import WaterHeaterFaq from "./sections/WaterHeaterFaq";
export default function WaterHeaterPage() {
  return <div>
      <Header />
      <WaterHeaterHero />
      <ProblemFinder />
      <WaterHeaterServices />
      <WaterHeaters />
      <RepairReplace />
      <BrandRibbon />
      <WaterHeaterProcess />
      <ServiceArea />
      <WaterHeaterFaq />
      <HeaterTrouble />
      <Footer />
    </div>;
}